module.exports = __webpack_public_path__ + "img/module-thumb.7c68fe45.jpg";